import { render, staticRenderFns } from "./UsersProfile.vue?vue&type=template&id=5fb1922a&scoped=true&"
import script from "./UsersProfile.vue?vue&type=script&lang=js&"
export * from "./UsersProfile.vue?vue&type=script&lang=js&"
import style0 from "./UsersProfile.vue?vue&type=style&index=0&id=5fb1922a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb1922a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fb1922a')) {
      api.createRecord('5fb1922a', component.options)
    } else {
      api.reload('5fb1922a', component.options)
    }
    module.hot.accept("./UsersProfile.vue?vue&type=template&id=5fb1922a&scoped=true&", function () {
      api.rerender('5fb1922a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/profile/UsersProfile.vue"
export default component.exports